
export class CommandsMessageCreator {
  createConnectionClosed = () => {
    const connectionClosed = new proto.netop.rc.commands.ConnectionClosed()
    connectionClosed.setMessageType(proto.netop.rc.commands.CommandsMessageType.CONNECTION_CLOSED)

    const msgBinary = connectionClosed.serializeBinary()
    return msgBinary
  }

  createChangeMonitor = (payload) => {
    const changeMonitor = new proto.netop.rc.commands.ChangeMonitor()
    changeMonitor.setMessageType(proto.netop.rc.commands.CommandsMessageType.CHANGE_MONITOR)
    changeMonitor.setSourceId(payload)

    const msgBinary = changeMonitor.serializeBinary()
    return msgBinary
  }

  createAudioChatStartRequest = () => {
    const cmd = new proto.netop.rc.commands.AudioChatStartRequest()
    cmd.setMessageType(proto.netop.rc.commands.CommandsMessageType.AUDIO_CHAT_START_REQUEST)
    return cmd.serializeBinary()
  }

  createAudioChatStartRequestCancel = () => {
    const cmd = new proto.netop.rc.commands.AudioChatStartRequestCancel()
    cmd.setMessageType(proto.netop.rc.commands.CommandsMessageType.AUDIO_CHAT_START_REQUEST_CANCEL)
    return cmd.serializeBinary()
  }

  createAudioChatStartResponse = (payload) => {
    const cmd = new proto.netop.rc.commands.AudioChatStartResponse()
    cmd.setMessageType(proto.netop.rc.commands.CommandsMessageType.AUDIO_CHAT_START_RESPONSE)
    cmd.setResponse(payload ? proto.netop.rc.commands.ResponseType.RT_YES : proto.netop.rc.commands.ResponseType.RT_NO)

    const msgBinary = cmd.serializeBinary()
    return msgBinary
  }

  createAudioChatEnd = () => {
    const cmd = new proto.netop.rc.commands.AudioChatEnd()
    cmd.setMessageType(proto.netop.rc.commands.CommandsMessageType.AUDIO_CHAT_END)
    return cmd.serializeBinary()
  }

  createAudioChatMicrophoneMuted = () => {
    const cmd = new proto.netop.rc.commands.AudioChatMicrophoneMuted()
    cmd.setMessageType(proto.netop.rc.commands.CommandsMessageType.AUDIO_CHAT_MICROPHONE_MUTED)
    return cmd.serializeBinary()
  }

  createAudioChatMicrophoneUnmuted = () => {
    const cmd = new proto.netop.rc.commands.AudioChatMicrophoneUnmuted()
    cmd.setMessageType(proto.netop.rc.commands.CommandsMessageType.AUDIO_CHAT_MICROPHONE_UNMUTED)
    return cmd.serializeBinary()
  }

  createSendClipboardRequest = (payload) => {
    const cmd = new proto.netop.rc.commands.ClipboardText()
    cmd.setMessageType(proto.netop.rc.commands.CommandsMessageType.CLIPBOARD_TEXT)
    cmd.setText(payload)
    return cmd.serializeBinary()
  }
}
